import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { persistStore } from 'redux-persist';
import { apiMiddleware } from 'redux-api-middleware';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { connectRoutes } from 'redux-first-router';
import { getRootReducer, getPersistedState } from 'app-webtech-core/reducers';
import { beaconMiddlewares } from 'app-webtech-core/beacon';
import { actions } from 'app-webtech-core/actions';
import { plutoApiInjectorMiddleware } from './plutoApiInjectorMiddleware';
import { groupRouteMaps } from './routes';

export { getPersistedState };

export const middlewares = [thunk, plutoApiInjectorMiddleware, apiMiddleware, ...beaconMiddlewares];
export const configureStore = ({
  preloadedState = {},
  customReducers = {},
  customPersistConfig = { whitelist: [], transforms: [] },
  customDevToolsOptions = { actionCreators: {}, actionsBlacklist: [] },
  routesDefinition = {},
  routeOptions,
}) => {
  const composeEnhancers = composeWithDevTools({
    ...customDevToolsOptions,
    actionCreators: {
      ...actions,
      ...(customDevToolsOptions.actionCreators || {}),
    },
    actionsBlacklist: ['PLAYER_TIME', ...(customDevToolsOptions.actionsBlacklist || [])],
  });

  const { routes: routesMap } = groupRouteMaps(routesDefinition);

  const {
    reducer: routerReducer,
    middleware: routeMiddleware,
    enhancer: routeEnhancer,
    thunk: routeThunk,
  } = connectRoutes(routesMap, routeOptions);

  const allMiddlewares = [...middlewares, routeMiddleware];

  const loadedMiddlewares = applyMiddleware(...allMiddlewares);

  const enhancer = composeEnhancers(routeEnhancer, loadedMiddlewares);

  const rootReducer = getRootReducer({
    routerReducer,
    routesMap,
    customReducers,
    customPersistConfig,
  });

  const store = createStore(rootReducer, preloadedState, enhancer);

  const persistor = persistStore(store);

  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('../reducers', () => {
      // eslint-disable-next-line global-require
      const getReloadedReducer = require('../reducers').getRootReducer;
      store.replaceReducer(
        getReloadedReducer({
          routerReducer,
          routesMap,
          customReducers,
        }),
      );
    });
  }

  return { store, persistor, routeThunk };
};
